package com.vizio.redwolf.auth.model

data class SendTermsRequestInfo(val accessToken: String)